// extracted by mini-css-extract-plugin
export var borderRadius = "_6d-4";
export var large = "_6d-3";
export var logoContainer = "_6d-0";
export var nameLogo = "_6d-2";
export var small = "_6d-1";